import firebase from "firebase"
import "firebase/storage"

const config = {
  apiKey: "AIzaSyBhqGnpq4cl5gnHiX1h-E6Et17hl2D6mb8",
  authDomain: "minpro-26e8e.firebaseapp.com",
  databaseURL: "https://minpro-26e8e.firebaseio.com",
  projectId: "minpro-26e8e",
  storageBucket: "minpro-26e8e.appspot.com",
  messagingSenderId: "680572186806",
  appId: "1:680572186806:web:309c3b911ba52f95aef617",
  measurementId: "G-FYJDTZMF09",
}

export const app = firebase.initializeApp(config)
export const db = app.firestore()
export const storage = app.storage()
export const minpuroproducts = db.collection("minpuroproducts")
